var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tsp",class:'tsp--' + _vm.kind},[_c('span',{staticClass:"tsp__dot",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }